import DataTable from "../components/UI/DataTable/DataTable";
import { PropertyEditContextProvider } from "../contexts/PropertyEditContext";
import TablePage from "./TablePage";

export default function DataIntegrity() {
	return (
		<TablePage title="Data Quality">
			<PropertyEditContextProvider>
				<DataTable editable displayIntegrity></DataTable>
			</PropertyEditContextProvider>
		</TablePage>
	);
}
